import React, { memo, useEffect } from 'react'
import { notification } from 'antd'
import zIndex from '@mui/material/styles/zIndex'
const getNotificationStyle = type => {
    return {
      success: {
        color: 'rgba(0, 0, 0, 1)',
        border: '1px solid #b7eb8f',
        backgroundColor: '#f6ffed',
        zIndex: 9999,
      },
      warning: {
        color: 'rgba(0, 0, 0, 1)',
        border: '1px solid #ffe58f',
        backgroundColor: '#fffbe6',
        zIndex: 9999,
      },
      error: {
        color: 'rgba(0, 0, 0, 1)',
        border: '1px solid #ffa39e',
        backgroundColor: '#fff1f0',
        zIndex: 9999,
      },
      info: {
        color: 'rgba(0, 0, 0, 1)',
        border: '1px solid #91d5ff',
        backgroundColor: '#e6f7ff',
        zIndex: 9999,
      }
    }[type]
}
const Notification = memo(({notificationData}) => {
    const [api, contextHolder] = notification.useNotification();
    
    useEffect(()=>{
        if (!notificationData?.success || typeof api[notificationData.success] !== 'function') return;
        const resolveMessage = (message) => {
            if (Array.isArray(message)) {
                return message.map(e => (typeof e === 'string' ? e : e?.msg || JSON.stringify(e))).join(', ');
            }
            if (message !== null && typeof message === 'object') {
                return message?.msg || JSON.stringify(message);
            }
            return message;
        };
        const openNotificationWithIcon = (notificationData) => {
            api[notificationData?.success]({
                message: resolveMessage(notificationData?.message),
                //closeIcon:'',
                style: getNotificationStyle(notificationData?.success),
                placement:'top',
                duration :10,
                zIndex: 99999,
            });
          };
        openNotificationWithIcon(notificationData)
        return ()=>{
        }
    },[notificationData])
    return(
        <>
        {contextHolder}
        </>
    )
})

export default Notification